import { useQuery } from '@tanstack/react-query';

import { listAvailableMenus } from './api';

/** `enabled` lets the form hold the query until the customer picks a unit (several units, none chosen yet). */
export function useMenuCalendar(
  serviceDate: string | undefined,
  operatingUnitId?: string,
  enabled = true,
) {
  return useQuery({
    queryKey: ['menu-calendar', serviceDate, operatingUnitId],
    queryFn: () => listAvailableMenus(serviceDate!, operatingUnitId),
    enabled: enabled && serviceDate !== undefined,
  });
}
